"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import locales from '../../../../../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import '@tabler/icons-react';
import '../../../../../../../Icon/Icon.mjs';
import '../../../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconContextMenu } from '../../../../../../../Icon/components/icons/IconContextMenu.mjs';
import ButtonView from '../../../../../../../../views/ButtonView.mjs';
import '../../../../../../../ContextMenu/ContextMenu.mjs';
import '../../../../../../../MenuItem/MenuItem.mjs';
import { ContextMenuTrigger } from '../../../../../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import 'react-aria-components';
import '../../../../../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';

const OptionsButton = (props) => {
  const { className, children } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  return /* @__PURE__ */ jsxs(ContextMenuTrigger, { children: [
    /* @__PURE__ */ jsx(
      ButtonView,
      {
        variant: "plain",
        color: "secondary",
        className,
        "aria-label": stringFormatter.format("list.options"),
        tunnelId: null,
        children: /* @__PURE__ */ jsx(IconContextMenu, {})
      }
    ),
    children
  ] });
};

export { OptionsButton, OptionsButton as default };
//# sourceMappingURL=OptionsButton.mjs.map
